import { render, staticRenderFns } from "./WebRTCPlayer.vue?vue&type=template&id=1bb64e96&scoped=true"
import script from "./WebRTCPlayer.vue?vue&type=script&lang=js"
export * from "./WebRTCPlayer.vue?vue&type=script&lang=js"
import style0 from "./WebRTCPlayer.vue?vue&type=style&index=0&id=1bb64e96&prod&lang=sass&scoped=true"
import style1 from "./WebRTCPlayer.vue?vue&type=style&index=1&id=1bb64e96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb64e96",
  null
  
)

export default component.exports